export default __webpack_public_path__ + "static/media/Hero.c680dc1f.png";